import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  ColorPickerComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { all_information, loadingShow } from '../../../App';
import { ThemeContext } from '../../../context/theme.context';
import Message from '../../../utils/Message/Message';
import './elementAliasStyle.css';
import 'react-jquery-plugin';
import ReactDOM from 'react-dom';
import { getValue } from '@syncfusion/ej2-base';
import {
  CheckBoxComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { BsCheck2 } from 'react-icons/bs';
import { BiX } from 'react-icons/bi';
import {
  addElementAlias,
  deleteElementAlias,
  editElementAlias,
  getElementAlias,
} from '../../../services/Settings/ElementAlias';

interface IProps {}
interface IState {
  elementAliasData: Array<any>;
}
export default class ElementAlias extends Component<IProps, IState> {
  private elementAliasGrid: GridComponent;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  constructor(props: IProps) {
    super(props);
    this.state = {
      elementAliasData: [],
    };
    this.elementAliasGrid = new GridComponent(props);
  }
  public validationRule: Object = { required: true };
  private isWorkbenchObj: any;
  private dropDownListObjectColor: any;
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getElementAlias();
    }
    if (
      this.elementAliasGrid &&
      args.item.id === 'gridElementAlias_excelexport'
    ) {
      this.elementAliasGrid.excelExport();
    }
  }
  SavePointEdit(data: any) {
    let color = this.dropDownListObjectColor.value;
    let isWorkbench = this.isWorkbenchObj.checked;
    var obj = {
      element_alias_description: data.element_alias_description,
      element_alias_name: data.element_alias_name,
      Colour: color,
      element_alias_id: Number(data.element_alias_id),
      isWorkbench: isWorkbench,
      app: 'UWORK',
      organization_id: all_information.company_id,
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    loadingShow(true, 'Edittig');

    editElementAlias(obj)
      .then((response: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getElementAlias();
        // this.context.setDataChangeShiftElement(true);
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error occured');
        //(e);
      });
  }
  SavePointAdd(data: any) {
    let color = this.dropDownListObjectColor.value;
    let isWorkbench = this.isWorkbenchObj.checked;
    var obj = {
      element_alias_description: data.element_alias_description,
      element_alias_name: data.element_alias_name,
      Colour: color,
      isWorkbench: isWorkbench,
      app: 'UWORK',
      organization_id: all_information.company_id,
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    loadingShow(true, 'Adding');
    addElementAlias(obj)
      .then((response: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getElementAlias();
        // this.context.setDataChangeShiftElement(true);
        // this.triggerContext();
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error occured');
        //(e);
      });
  }
  deletePoint = (obje: any) => {
    const obj = JSON.stringify({
      element_alias_id: obje[0].element_alias_id,
    });
    loadingShow(true, 'Deleting');
    deleteElementAlias(obj)
      .then((response: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getElementAlias();
        // this.triggerContext();
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error occured');
      });
  };
  triggerContext() {
    this.context.setDataChangeShiftElement(true);
  }
  componentDidMount() {
    this.getElementAlias();
  }
  getElementAlias() {
    getElementAlias(false).then((response: any) => {
      this.setState({ elementAliasData: response.data });
    });
  }
  private isWorkbenchtemplate(args: any) {
    let isChecked = args.isWorkbench;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isWorkbenchtemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.isWorkbench}
        ref={(scope) => (this.isWorkbenchObj = scope)}
      />
    );
  }
  actionBeginElementAlias(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.deletePoint(args.data);
    }
  }
  private colorEditTemplate(args: any) {
    return (
      <ColorPickerComponent
        value={args.Colour}
        ref={(scope) => (this.dropDownListObjectColor = scope)}
      />
    );
  }
  private colorTemplate(args: any) {
  return (
      <div
      style={{
        width: 20,
        height: 20,
        borderRadius: 3,
        backgroundColor: args.Colour,
        margin: '5px 0px 5px 8px',
      }}
    />
  );
}
  render() {
    return (
      <div>
        <GridComponent
          id='gridElementAlias'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.elementAliasData}
          height='80.8vh'
          ref={(theGrid: GridComponent) => (this.elementAliasGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginElementAlias.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='colour'
              headerText='#'
              textAlign='Left'
              width={25}
              template={this.colorTemplate.bind(this)}
              editTemplate={this.colorEditTemplate.bind(this)}
            />
            <ColumnDirective
              field='element_alias_name'
              headerText='Alias name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='element_alias_description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='isWorkbench'
              headerText='Is Workbench'
              textAlign='Center'
              width={45}
              template={this.isWorkbenchtemplate.bind(this)}
              editTemplate={this.isWorkbenchtemplateEditing.bind(this)}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}
